export default __webpack_public_path__ + "static/media/070_boost.first.3b53e360.webp";